import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Hidden } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    menuIconCurtain: {
        position: 'fixed',
        bottom: '50px',
        right: '25px'
    },
    menuIcon: {
        background: theme.palette.text.secondary,
        position: 'relative',
        borderRadius: '22px',
        height: '44px',
        width: '44px',
        transform: 'scale(1.5)',

        '& .toggle': {
            display: "block",
            cursor: "pointer",
            position: 'absolute',
            left: '12px',
            top: '15px',

            '& input' : {
                display: "none",
                '& + div': {
                    width: "20px",
                    height: "14px",
                    position: "relative",

                    '& div': {
                        position: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        transition: "transform .5s ease",

                        '& span': {
                            display: "block",
                            position: "absolute",
                            left: 0,
                            right: 0,

                            '&:first-child': {
                                top: 0,
                                '&:before': {
                                    top: 0
                                },
                                '&:after': {
                                    top: 0
                                }
                            },

                            '&:last-child': {
                                bottom: 0,
                                '&:before': {
                                    bottom: 0
                                },
                                '&:after': {
                                    bottom: 0
                                }
                            },

                            '&:before': {
                                left: 0,
                                transformOrigin: "0 50%",
                                transform: "translate(1px, 0) scaleX(1.1)",
                                content: '""',
                                display: "block",
                                width: "47%",
                                height: "2px",
                                borderRadius: "1px",
                                background:  "#fff",
                                position: "absolute",
                                "-webkit-backface-visibility": "hidden",
                                transition: "transform .5s ease, border-radius .3s ease, background .4s ease"
                            },
                            '&:after': {
                                right: 0,
                                transformOrigin: "100% 50%",
                                transform: "translate(-1px, 0) scaleX(1.1)",
                                content: '""',
                                display: "block",
                                width: "47%",
                                height: "2px",
                                borderRadius: "1px",
                                background:  "#fff",
                                position: "absolute",
                                "-webkit-backface-visibility": "hidden",
                                transition: "transform .5s ease, border-radius .3s ease, background .4s ease"
                            }
                        }
                    },
                    '& svg': {
                        display: "block",
                        fill: "none",
                        stroke:  "#fff",
                        strokeWidth: "2px",
                        width: "44px",
                        height: "44px",
                        strokeLinecap: "round",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        margin: "-22px 0 0 -22px",
                        strokeDasharray: "0 82.801 8 82.801",
                        strokeDashoffset: "82.801",
                        transformOrigin: "50% 50%",
                        "-webkit-backface-visibility": "hidden",
                        transform: "scale(1)",
                        transition: "stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease",
                        '&:nth-child(3)':  {
                            transform:" rotate(180deg) scale(1)"
                        }
                    }

                },

                '&:checked + div': {
                    '& div': {
                        transform: "rotate(90deg)",
                        '& span': {
                            '&:before': {
                                background: "#fff"
                            },
                            '&:after': {
                                background: "#fff"
                            },
                            '&:first-child': {
                                '&:before': {
                                    transform: "rotate(45deg) translate(2.2px, -3px) scaleX(1.05)"
                                },
                                '&:after': {
                                    transform: "rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05)"
                                },
                            },
                            "&:last-child": {
                                "&:before": {
                                    transform: "rotate(-45deg) translate(2.2px, 3px) scaleX(1.05)"
                                },
                                "&:after": {
                                    transform: "rotate(45deg) translate(-2.2px, 3px) scaleX(1.05)"
                                }
                            }
                        }
                    },

                    "& svg": {
                        strokeDashoffset: "62",
                        strokeDasharray: "0 82.801 62 82.801",
                        transform: "rotate(90deg)",
                        stroke: "#fff",
                        
                        "&:nth-child(3)": {
                            transform: "rotate(270deg)"
                        }
                    }
                }
            }
        }
    }
}));

const MenuIcon = (props) => {
    const classes = useStyles(props);
    return(
        <React.Fragment>
            <div className={classes.menuIconCurtain}>
                <div className={classes.menuIcon}>
                    <label className="toggle">
                        <input type="checkbox" />
                        <div>
                            <div>
                                <span></span>
                                <span></span>
                            </div>
                            <svg>
                                <use xlinkHref={`#path`} />
                            </svg>
                            <svg>
                                <use xlinkHref={`#path`} />
                            </svg>
                        </div>
                    </label>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{display: "none"}}>
                        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="path">
                            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22"></path>
                        </symbol>
                    </svg>
                </div>
            </div>
        </React.Fragment>
    )
};

export default (props) => {
    const classes = useStyles(props);

    return <React.Fragment>
        <Hidden smUp={true} implementation="css">
            <MenuIcon />
        </Hidden>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/client/components/MobileMenu.js